export default {
    'Menu': 'Меню'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/oncanvas/translations/ru.js
// module id = 436
// module chunks = 0